import api from '../../utils/api'
import { useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormStockItem from './form/FormStockItem'

function NewStockItem({ btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    async function registerItem(item) {
        let msgType = 'success'

        const data = await api.post('/stock/general/new', item, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => response.data)
            .catch((err) => { msgType = 'error'; return err.response.data })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        <FormStockItem title="Cadastrar Item de Estoque" handleSubmit={registerItem} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewStockItem
